import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { AdvertisingMarqueeService } from './service/advertising-marquee.service';
import { AdvertisingService } from './service/advertising.service';
import { BankService } from './service/bank.service';
import { EventS } from './service/event.s';
import { AuthService } from './service/auth.service';
import { ConstantsService } from './service/constants.service';
import { DataProviderService } from './service/data-provider.service';
import { InvoicesService } from './service/invoices.service';
import { NotificationService } from './service/notification.service';
import { SliderImgHomeService } from './service/slider-img-home.service';
import { SocketService } from './service/socket.service';
import { TaxesService } from './service/taxes.service';
import { UserService } from './service/user.service';
import { AuthGuard } from "./service/auth.guard";
import { httpMadhuramAdminJwtInterceptor } from "./interceptor/http-madhuram-admin-jwt.interceptor";
import { LoginG } from "./guards/login.g";

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: setUserFromLocalStorage,
            deps: [AuthService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: setAMUserFromLocalStorage,
            deps: [UserService],
            multi: true,
        },


        provideRouter(routes),
        AuthService,
        UserService,
        DialogService,
        MessageService,
        DataProviderService,
        NotificationService,
        ConfirmationService,
        ConstantsService,
        TaxesService,
        InvoicesService,
        SocketService,
        AdvertisingService,
        SliderImgHomeService,
        AdvertisingMarqueeService,
        BankService,
        EventS,
        AuthGuard,
        LoginG,
        provideClientHydration(),
        provideHttpClient(withInterceptors([
            httpMadhuramAdminJwtInterceptor,
        ])),
        provideAnimations()]
};

export function setUserFromLocalStorage(authCS: AuthService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = authCS.getUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    authCS.gUser = localStorageUser;
                    authCS.token.accessToken = <any>authCS.gUser.accessToken;
                    authCS.token.refreshToken = <any>authCS.gUser.refreshToken;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}

export function setAMUserFromLocalStorage(userS: UserService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = userS.getAMUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    userS.amUser = localStorageUser;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}
